import React from "react";
import { motion } from "framer-motion";
import BrandInfo from "./BrandInfo";
import { Brand, BrandList, Location, Tag } from "../types/mapData";
import expand from "../../../../assets/images/map_v2/expand_more.svg";

interface MobileBrandInfoProps {
  curLoc: Location;
  brands: BrandList | null;
  cloudinaryPath: string;
  userLocErr: boolean;
  handleBrandInfoClick: (
    location: Location,
    marker: google.maps.Marker,
    brandId?: number,
  ) => void;
  setInfoOpenMobile: (open: boolean) => void;
  infoOpenMobile: boolean;
  tags: Tag[] | null;
  getFeaturedTags: (brand?: Brand) => string[];
  loadingDetails: boolean;
  curMarkerRef?: React.RefObject<google.maps.Marker>;
  oval: string;
  counter: number;
}

const MobileBrandInfo: React.FC<MobileBrandInfoProps> = ({
  curLoc,
  brands,
  cloudinaryPath,
  userLocErr,
  handleBrandInfoClick,
  setInfoOpenMobile,
  infoOpenMobile,
  tags,
  getFeaturedTags,
  loadingDetails,
  curMarkerRef,
  oval,
  counter,
}) => {
  return (
    <motion.div
      className="mobile-brand-info"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <BrandInfo
        location={curLoc}
        brandToUse={brands?.[curLoc.brand_id]}
        cloudinaryPath={cloudinaryPath}
        userLocErr={userLocErr}
        handleBrandInfoClick={handleBrandInfoClick}
        key={curLoc.name}
        tags={tags}
        getFeaturedTags={getFeaturedTags}
        loadingDetails={loadingDetails}
        curMarkerRef={curMarkerRef}
        oval={oval}
      />
      <a
        href="#"
        onClick={() => {
          infoOpenMobile === false
            ? setInfoOpenMobile(true)
            : setInfoOpenMobile(false);
        }}
      >
        <div className="pass-button">
          Learn More
          <img src={expand} alt="inKind Pass" className="arrow-logo" />
        </div>
      </a>
    </motion.div>
  );
};

export default MobileBrandInfo;
